<template>
  <span>
    <div v-if="Number(regular) !== -1 && Number(special) !== -1" class="showPriceItem">
      <SfPrice :regular="regular ? $n(
        regular,
        'currency'
      ) : ''
        " :special="special?$n(special, 'currency'): '' " style="--price-special-font-weight:600" />
    </div>
    <div v-else class="showPriceItem">
      <SfPrice :regular="'???'
        " style="--price-special-font-weight:600" /> <SfButton class="sf-button--text" style="margin-left:5px;" @click="handleLoiginClick"> {{ $t('login.showPrice') }} </SfButton>
    </div>
  </span>
</template>
<script>
import {
  SfPrice,
  SfButton
} from '@storefront-ui/vue';
import { useUiState } from '~/composables';
export default {
  name: "ShowPrice",
  props: {
    regular: {
      default: null
    },
    special: {
      default: null
    },
  },
  setup(props) {
    const { toggleLoginModal } = useUiState();
    const handleLoiginClick = ()=>{
      toggleLoginModal();
    }
    return {
      handleLoiginClick
    }
  },
  components: {
    SfPrice,
    SfButton
  }
};
</script>
<style lang="scss" scoped>
.showPriceItem {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;

  .sf-price {
    align-items: baseline;
    flex-direction: row-reverse;

    * {
      line-height: 18px;
    }

    .sf-price__old {
      margin-left: 5px;
    }
  }
}
</style>